module.exports = __webpack_public_path__ + "img/BRCA1_Neutrophils.3f7ee640.png";